module.exports = __webpack_public_path__ + "img/aside-left-bg.d3b23ca4.png";